export { default } from './EditFormBlock';

export const displayName = 'Form';
